<template>
  <div class="mt-2">
    <v-layout>
      <v-flex>
        <div class="text-xs-right">
          <v-btn @click="cancelImportRedeemCode" icon> <v-icon>close</v-icon></v-btn>
        </div>
      </v-flex>
    </v-layout>

    <div class="px-3 pb-3">
      <h3 v-if="!editData" class="headline mt-3">{{ $t('Add Redeem Codes') }}</h3>
      <h3 v-else class="headline mt-3">{{ $t('Redeem Codes') }}</h3>
      <!-- Category -->
      <template v-if="loadingCategory">
        <div class="text-left">
          <scale-loader
            :color="$vuetify.theme.primary"
            height="20px"
            width="5px"
            style="max-width: 50px"
          ></scale-loader>
        </div>
      </template>
      <template v-else>
        <div class="form-control" :class="{ 'has-error': errors.has('categoryInput') }">
          <label for="categoryInput" class="caption"
            >{{ $t('Member Type') }} <span class="red--text">*</span></label
          >
          <v-radio-group
            v-validate="'required'"
            v-model="category"
            name="categoryInput"
            row
            class="ma-0"
            @click="onChangeCategory"
            :data-vv-as="$t('Member Type')"
          >
            <template v-for="(item, index) in categorylist">
              <v-radio color="primary" :key="index" :label="item.name" :value="item"></v-radio>
            </template>
          </v-radio-group>
          <span class="text-error" v-show="errors.has('categoryInput')">
            {{ errors.first('categoryInput') }}
          </span>
        </div>
      </template>

      <!-- SubCategory -->
      <template v-if="loadingSubCategory">
        <div class="text-left">
          <scale-loader
            :color="$vuetify.theme.primary"
            height="20px"
            width="5px"
            style="max-width: 50px"
          ></scale-loader>
        </div>
      </template>
      <template v-else>
        <div
          v-if="category"
          class="form-control"
          :class="{ 'has-error': errors.has('subcategoryInput') }"
        >
          <label v-if="subcategorylist" for="subcategoryInput" class="caption"
            >{{ $t('Sub Category') }} <span class="red--text">*</span></label
          >
          <v-radio-group
            v-validate="'required'"
            v-model="subcategory"
            :data-vv-as="$t('Sub Category')"
            name="subcategoryInput"
            row
            class="ma-0"
            @click="onChangeSubCategory"
          >
            <template v-for="(item, index) in subcategorylist">
              <v-radio color="primary" :key="index" :label="item.name" :value="item"></v-radio>
            </template>
          </v-radio-group>
          <span class="text-error" v-show="errors.has('subcategoryInput')">
            {{ errors.first('subcategoryInput') }}
          </span>
        </div>
      </template>

      <div
        v-if="subcategory"
        class="form-control mb-3"
        :class="{ 'has-error': errors.has('giftInput') }"
      >
        <label for="giftInput" class="caption"
          >{{ $t('Gift') }} <span class="red--text">*</span></label
        >
        <!-- <v-autocomplete
            v-if="giftList"
            :data-vv-as="$t('Gift')"
            v-validate="'required'"
            v-model="gift"
            :items="giftList"
            color="primary"
            item-text="name"
            name="giftInput"
            label="Gift"
            outline
            return-object
          ></v-autocomplete> -->
        <Multiselect
          v-if="giftList"
          @input="$emit('change', $event)"
          :placeholder="$t('Gift')"
          v-model="gift"
          :options="giftList"
          label="name"
          color="primary"
          :data-vv-as="$t('Gift')"
          v-validate="'required'"
          name="giftInput"
        ></Multiselect>
        <span class="text-error" v-show="errors.has('giftInput')">
          {{ errors.first('giftInput') }}
        </span>
      </div>
      <div v-if="gift" :class="{ 'has-error': errors.has('importCodeInput') }">
        <label for="importCodeInput" class="caption"
          >{{ $t('Import Code') }} <span class="red--text">*</span></label
        >
        <div>
          <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
          <span v-if="importCodeStatus" class="green--text">Upload file successfully</span>
        </div>
        <span class="text-error red--text" v-show="errors.has('importCodeInput')">
          {{ errors.first('importCodeInput') }}
        </span>
      </div>

      <div class="text-xs-center">
        <v-btn outline color="grey" @click="cancelImportRedeemCode">{{ $t('cancel') }}</v-btn>
        <v-btn depressed color="primary" @click="saveImportRedeemCode">{{ $t('Save') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
// import SelectCategory from '@/components/view/template/ecommerce/SelectCategory.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import importxlsx from '@/components/elements/importxlsx.vue'

export default {
  props: ['editData'],
  data() {
    return {
      limit: 10,
      offset: 0,
      loadingCategory: false,
      loadingSubCategory: false,
      loadingGift: false,
      importloading: false,
      categorylist: [],
      subcategorylist: [],
      giftList: [],

      category: '',
      subcategory: '',
      gift: '',
      importCode: '',
      importCodeStatus: false
    }
  },
  components: {
    ScaleLoader,
    goTo,
    Multiselect,
    importxlsx
  },
  mounted() {
    this.getCategories()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    moment() {
      return moment
    }
  },
  methods: {
    getCategories() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.limit,
        offset: vm.offset
      }

      vm.loadingCategory = true
      api.getLamyGiftCategory(data, function (error, response) {
        if (response.responsecode == 200) {
          vm.categorylist = response.data
          vm.loadingCategory = false
        } else {
          console.error(error)
          return
        }
      })
    },
    async getSubCategories(category) {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        category_id: category.id,
        limit: vm.limit,
        offset: vm.offset
      }

      vm.loadingSubCategory = true
      await api.getLamyGiftSubCategory(data, function (error, response) {
        if (response.responsecode == 200) {
          vm.subcategorylist = response.data
          vm.loadingSubCategory = false
        } else {
          console.error(error)
          return
        }
      })
    },
    async getGift(subCategory) {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        sub_category_id: subCategory.id,
        limit: vm.limit,
        offset: vm.offset
      }

      vm.loadingGift = true
      await api.getLamyGiftProducts(data, function (error, response) {
        if (response && response.responsecode == 200) {
          var giftOptions = []
          $.each(response.data, function (index, val) {
            giftOptions.push({ name: val.name, id: val.id })
          })

          vm.giftList = giftOptions
          vm.loadingGift = false
        } else {
          console.error(error)
          return
        }
      })
    },
    onChangeCategory() {
      this.subcategory = ''
      this.gift = ''
      this.giftList = []
    },
    onChangeSubCategory() {
      this.gift = ''
      this.giftList = []
    },
    onImport(item) {
      var vm = this
      vm.importloading = true
      vm.importCode = item[0]
      vm.importloading = false
      vm.importCodeStatus = true
    },
    async saveImportRedeemCode() {
      var vm = this
      var result = await vm.$validator.validateAll()
      if (!result) {
        vm.goToErrorInput()
        return false
      }

      var data = {
        pageid: vm.selectedBot.pageid,
        product_id: vm.gift.id,
        product_name: vm.gift.name,
        gift_type: vm.subcategory.name,
        member_type: vm.category.name,
        files: vm.importCode
      }

      await api.postLamyRedeemImport(data, async (err, response) => {
        if (response.responsecode == 200) {
          vm.$emit('onImportCode')
          vm.$emit('close')
          vm.cancelImportRedeemCode()
        } else if (response.responsecode == 204) {
          Vue.swal.fire({ text: e.response.data.reason })
        } else {
          console.error(error)
          return
        }
      })
    },
    cancelImportRedeemCode() {
      this.category = ''
      this.subcategory = ''
      this.gift = ''
      this.importCode = ''
      this.$emit('close')
    }
  },
  watch: {
    category: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getSubCategories(this.category)
      }
    },
    subcategory: function (newVal, oldVal) {
      if (this.subcategory) {
        this.getGift(this.subcategory)
      }
    }
  }
}
</script>

<style scroped>
.caption {
  font-size: 14px !important;
}
.v-btn-toggle .v-btn.v-btn--active {
  background-color: #ff706b !important;
  border-color: #ff706b !important;
  color: #fff;
}
.text-error {
  padding-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/ModalImportRedeemCode.vue